
import { Options, Vue }    from 'vue-class-component';
import SurfaceInput from '../components/shared/surface-input.vue'
import {reactive, ref} from 'vue';

@Options({
  components: {
    SurfaceInput
  },
  data() {
    return {
      tiles: this.$store.state.selectedTiles || [],
      errors: this.$store.state.errors || {}
    }
  },
  setup(){
    const formRef = ref();

    const formState = reactive({
      quantity: undefined
    });

    return {
      formRef,
      formState
    }
  },
  watch: {
    '$store.state.counter'(){
      this.onSubmit();
    }
  },
  methods: {
    onSubmit(){
      const errors = this.$store.state.errors
      this.$refs.formRef
          .validate()
          .then(() => {
            errors['pavingSurface'] = null
            this.$store.commit('setActiveErrors',errors)
            this.$router.push(this.$router.currentRoute.value.meta.next)
          })
          .catch(error => {
            errors['pavingSurface'] = 'Polje je obvezno!'
            this.$store.commit('setActiveErrors',errors)
            console.log('error', error);
          });
    }
  }

  })
export default class PavingSurface extends Vue {}
